@import '~@union-investment/global-resources/src/styles/solid-design-system';

$white-gradient-left: linear-gradient(
  270deg,
  rgb(255 255 255 / 0%) 20%,
  rgb(255 255 255 / 40%) 40%,
  rgb(255 255 255 / 85%) 100%
);
$white-gradient-right: linear-gradient(
  90deg,
  rgb(255 255 255 / 0%) 20%,
  rgb(255 255 255 / 40%) 40%,
  rgb(255 255 255 / 85%) 100%
);
$white-gradient-mobile: linear-gradient(90deg, rgb(255 255 255 / 80%) 0%, rgb(255 255 255 / 65%) 100%);
$black-gradient-left: linear-gradient(
  270deg,
  rgb(24 24 24 / 0%) 25%,
  rgb(24 24 24 / 40%) 50%,
  rgb(24 24 24 / 75%) 100%
);
$black-gradient-right: linear-gradient(
  90deg,
  rgb(24 24 24 / 0%) 25%,
  rgb(24 24 24 / 40%) 50%,
  rgb(24 24 24 / 75%) 100%
);
$black-gradient-mobile: linear-gradient(270deg, rgb(24 24 24 / 65%) 50%, rgb(24 24 24 / 80%) 100%);

$white-gradient-left--high-contrast: linear-gradient(
  270deg,
  rgb(255 255 255 / 0%) 15%,
  rgb(255 255 255 / 50%) 40%,
  rgb(255 255 255 / 90%) 100%
);
$white-gradient-right--high-contrast: linear-gradient(
  90deg,
  rgb(255 255 255 / 0%) 10%,
  rgb(255 255 255 / 50%) 40%,
  rgb(255 255 255 / 90%) 100%
);
$black-gradient-left--high-contrast: linear-gradient(
  270deg,
  rgb(24 24 24 / 0%) 15%,
  rgb(24 24 24 / 50%) 40%,
  rgb(24 24 24 / 85%) 100%
);
$black-gradient-right--high-contrast: linear-gradient(
  90deg,
  rgb(24 24 24 / 0%) 25%,
  rgb(24 24 24 / 50%) 50%,
  rgb(24 24 24 / 85%) 100%
);

:host {
  display: block;

  .ui-cms-quotation {
    container-type: inline-size;
    margin: 0;

    &.sd-copyright::after {
      z-index: 10;
    }

    &--black {
      color: $sd-textColor-black;
    }

    &--white {
      color: $sd-textColor-white;
    }

    &--with-image {
      .ui-cms-quotation__wrapper {
        height: 0;
        overflow: hidden;
        padding-bottom: calc(100% * (6 / 5));
        position: relative;

        @container (min-width: 500px) {
          padding-bottom: calc(100% * (9 / 16));
        }
      }
    }

    &__quote-container {
      q {
        display: block;
        margin-bottom: $sd-spacing-6;
        line-height: 1.25;
        overflow-wrap: break-word;
        position: relative;
        word-wrap: break-word;

        &.ui-cms-quotation__quote--large {
          font-size: $sd-fontSize-3xl;

          @container (max-width: 764px) {
            font-size: $sd-fontSize-2xl;
          }
        }

        &.ui-cms-quotation__quote--medium {
          font-size: $sd-fontSize-xl;

          @container (max-width: 764px) {
            font-size: $sd-fontSize-lg;
          }
        }

        &.ui-cms-quotation__quote--small {
          font-size: $sd-fontSize-lg;
        }
      }

      &--with-image {
        background-color: transparent;
        background-position: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: $sd-spacing-8;
        width: 100%;
        position: absolute;
        z-index: 10;

        @container (max-width: 500px) {
          padding: $sd-spacing-6;
        }
      }

      &--position-left {
        left: 0;
        background-image: $white-gradient-mobile;

        &.ui-cms-quotation__quote-container--dark-bg {
          background-image: $black-gradient-mobile;

          @container (min-width: 500px) {
            background-image: $black-gradient-left;

            &.ui-cms-quotation__quote-container--bg-high-contrast {
              background-image: $black-gradient-left--high-contrast;
            }
          }
        }

        @container (min-width: 500px) {
          padding-right: 50%;
          background-image: $white-gradient-left;

          &.ui-cms-quotation__quote-container--bg-high-contrast {
            background-image: $white-gradient-left--high-contrast;
          }
        }
      }

      &--position-right {
        right: 0;
        background-size: auto;
        background-image: $white-gradient-mobile;

        &.ui-cms-quotation__quote-container--dark-bg {
          background-image: $black-gradient-mobile;

          @container (min-width: 500px) {
            background-image: $black-gradient-right;

            &.ui-cms-quotation__quote-container--bg-high-contrast {
              background-image: $black-gradient-right--high-contrast;
            }
          }
        }

        @container (min-width: 500px) {
          padding-left: 50%;
          background-image: $white-gradient-right;

          &.ui-cms-quotation__quote-container--bg-high-contrast {
            background-image: $white-gradient-right--high-contrast;
          }
        }
      }

      &--position-top {
        top: 0;
        background-position-y: bottom;
      }

      &--position-bottom {
        bottom: 0;
        justify-content: flex-end;
        background-position-y: top;
      }
    }

    &__background-image {
      &--overflow {
        margin-bottom: $sd-spacing-4;
      }

      img {
        display: block;
        height: 100%;
        left: 0;
        object-fit: cover;
        position: absolute;
        top: 0;
        width: 100%;
      }
    }

    &__meta {
      display: flex;
      align-items: center;
      gap: $sd-spacing-4;

      &__author-image {
        img {
          width: $sd-spacing-16;
          height: $sd-spacing-16;
          border-radius: 9999px;
          overflow: hidden;
          object-fit: cover;
          flex-shrink: 0;
        }
      }

      &__author-name {
        font-weight: $sd-fontWeight-bold;
        margin-bottom: $sd-spacing-1;
      }
    }
  }
}
